import { SERVICES } from "@/data/site";
import { Reveal } from "@/components/motion/Reveal";
import { motion } from "framer-motion";

export const Services = () => {
  return (
    <section id="services" className="section bg-[#0A0A0A] relative">
      <div className="container-x">
        <div className="flex items-end justify-between flex-wrap gap-6 mb-20">
          <Reveal>
            <div>
              <div className="text-xs uppercase tracking-[0.4em] text-accent mb-4">/ 01 The Menu</div>
              <h2 className="font-display text-5xl sm:text-7xl text-white leading-none" data-testid="services-title">
                CLEAN CUTS.
                <br />
                CLEAN PRICES.
              </h2>
            </div>
          </Reveal>
          <Reveal delay={0.2}>
            <p className="text-dim max-w-md text-base">
              No hidden fees, no upcharges. What you see is what you pay. Walk out
              sharper than you walked in — every single time.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-[#27272A] border border-[#27272A] rounded-md overflow-hidden">
          {SERVICES.map((s, i) => (
            <motion.article
              key={s.id}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.7, delay: i * 0.07, ease: [0.22, 1, 0.36, 1] }}
              data-testid={`service-card-${s.id}`}
              className="bg-[#0A0A0A] p-8 md:p-10 hover:bg-[#121212] transition-colors group relative overflow-hidden"
            >
              <div className="absolute left-0 top-0 h-full w-1 bg-accent scale-y-0 group-hover:scale-y-100 transition-transform origin-top duration-500" />
              <div className="flex items-start justify-between mb-6">
                <span className="text-xs uppercase tracking-[0.3em] text-dim">0{i + 1}</span>
                <span className="font-display text-4xl text-accent">${s.price}</span>
              </div>
              <h3 className="font-display text-3xl text-white mb-3 tracking-wide group-hover:translate-x-1 transition-transform">
                {s.name}
              </h3>
              <p className="text-dim text-sm leading-relaxed">{s.description}</p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};
